import { IResource } from '../../common/interfaces/cis/client';
import { get } from '../utility/Requests.default';

export const externalApiResourceUrl = `${process.buildConfigs.identityApiBaseRoute}/ExternalApiResource`;

export function getExternalApiResources() {
    return get<IResource[]>(externalApiResourceUrl);
}
